import { render, staticRenderFns } from "./expedia.vue?vue&type=template&id=206fa95e&scoped=true&"
import script from "./expedia.vue?vue&type=script&lang=js&"
export * from "./expedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fa95e",
  null
  
)

export default component.exports